export const getLinePathByDroppableId = (droppableId: string) => {
  return droppableId.split('_').map(item => Number(item.replace(/(containerId|tabId):/g, '')))
}
